export default __webpack_public_path__ + "static/media/Level17.3059fbcf.svg";